module.exports = __webpack_public_path__ + "static/media/9.759a041b.png";